























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DropdownInput extends Vue {
  @Prop() value!: string;

  @Prop() items!: [string];

  private open = false;

  toggleOpen() {
    this.open = !this.open;
  }

  select(selected: string) {
    this.$emit('value-change', selected);
    this.toggleOpen();
  }
}
